/**
 * Image Gallery Handling
 *
 * @type {AsyncDynamicInitFunction<HTMLElement>}
 */
export default async ($collection) => {
	await import('./image-gallery/fancybox.js');
};